import { render, staticRenderFns } from "./uOttawa1321IntroductionLab5Fr.vue?vue&type=template&id=4a986d5d&scoped=true&"
import script from "./uOttawa1321IntroductionLab5Fr.vue?vue&type=script&lang=js&"
export * from "./uOttawa1321IntroductionLab5Fr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a986d5d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VRow,VSimpleTable,VTextField})
